<template>
  <div v-if="items && items.length > 0" class="bg-gray-300">
    <UContainer :class="sectionContainer.internal">
      <TTitle tag="h2" size="3xl">
        {{ t('views.cottage-list.closeCottages.title', { title }) }}</TTitle
      >
      <div v-for="item in items" :key="item.title" class="my-8">
        <TText tag="h3" variant="semibold">
          {{ item.title }}
        </TText>
        <TGrid :gap-y="4">
          <UButton
            v-for="(link, index) in item.seoEntities"
            :key="index"
            variant="link"
            color="neutral"
            size="sm"
            :to="link.url"
            external
            class="col-span-12 md:col-span-3 no-underline"
            >{{ link.name }}</UButton
          >
        </TGrid>
      </div>
      <UButton
        v-if="destination?.type === 'province'"
        variant="link"
        color="neutral"
        size="sm"
        :to="routes().otherDestinations({ slug: destination.slug })"
        external
        class="mt-4 no-underline"
        data-test="othersButton"
        >{{ t('views.cottage-list.closeCottages.others') }}</UButton
      >
    </UContainer>
  </div>
</template>
<script setup lang="ts">
import { sectionContainer } from '~~/modules/design-system/utils/nuxt-ui-config/components/container'

defineProps<{
  items: Array<{
    title: string
    seoEntities: Array<{
      name: string
      url: string
    }>
  }>
  title: string
  destination: {
    type: 'province' | 'village' | 'region' | 'zone'
    slug: string
  } | null
}>()
</script>
